
























import { api } from "@/api";
import Vue from "vue";
import Component from "vue-class-component";
import { Toast } from "vant";

@Component
export default class Agent extends Vue {
  protected loading: boolean = false;
  protected lists: any[] = [];
  protected finished: boolean = true;
  protected searchValue: string = "";

  public async onSearch() {
    const resp = await api.agentSearch({ nickname: this.searchValue });

    console.log(resp);
    if (resp.list.length <= 0) {
      Toast("该用户未绑定");
    }

    this.lists = resp.list;
  }
}
